import currentStatusApi from '@/api/currentStatus';

const SET_CURRENT_STATUS = 'SET_CURRENT_STATUS';
const START_CURRENT_STATUS_POOL = 'START_CURRENT_STATUS_POOL';
const STOP_CURRENT_STATUS_POOL = 'STOP_CURRENT_STATUS_POOL';

const state = {
  currentStatus: [],
  currentStatusPool: undefined
};

const getters = {
  getCurrentStatus: state => {
    return state.currentStatus;
  }
};

const mutations = {
  [SET_CURRENT_STATUS] (state, status) {
    state.currentStatus = status;
  },
  [START_CURRENT_STATUS_POOL] (state, {context, globalTags, groupTags}) {
    callCurrentStatus(context, state, globalTags, groupTags);
    state.cellCurrentStatusPool = setInterval(() => {
      callCurrentStatus(context, state, globalTags, groupTags);
    }, 60000);
  },
  [STOP_CURRENT_STATUS_POOL] (state) {
    if (state.cellCurrentStatusPool) {
      clearInterval(state.cellCurrentStatusPool);
      state.cellCurrentStatusPool = undefined;
    }
  }
};

const actions = {
  startRetrieveCurrentStatus ({ commit }, {context, globalTags, groupTags}) {
    commit(START_CURRENT_STATUS_POOL, {context, globalTags, groupTags});
  },
  stopRetrieveCurrentStatus ({ commit }) {
    commit(STOP_CURRENT_STATUS_POOL);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};

const callCurrentStatus = (context, state, globalTags, groupTags) => {
  currentStatusApi.getCurrentStatus(context, globalTags, groupTags).then(response => {
    state.currentStatus = response;
  });
};



// WEBPACK FOOTER //
// ./src/store/modules/currentStatus/index.js